import React from "react";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

function SocialLinks() {
   return (
      <section className="w-full bg-white py-12 md:py-16 lg:py-24 px-6 text-center">
         <h3 className="text-title font-bold text-dark-1 mb-6">🌐 Suis-nous pour ne rien manquer</h3>
         <div className="flex justify-center gap-6">
            <a href="#" className="text-blue-1 hover:opacity-80"><Facebook size={32} /></a>
            <a href="#" className="text-blue-1 hover:opacity-80"><Instagram size={32} /></a>
            <a href="#" className="text-blue-1 hover:opacity-80"><Linkedin size={32} /></a>
            <a href="#" className="text-blue-1 hover:opacity-80"><Youtube size={32} /></a>
         </div>
      </section>
   )
};

export default SocialLinks;